import {PUSH_VALUE} from "../constants/constants";

export const pushBuildValue  = (value) => {
    return{
        type : PUSH_VALUE,
        payload : value
    };
};


// WEBPACK FOOTER //
// ./src/actions/pushBuildValue.js